var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbDownStylized = function SvgThumbDownStylized(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DC0045",
    fillOpacity: 0.2,
    d: "M.164 10.382c-.576-2.836.84-5.778 4.035-7.085 3.194-1.306 9.784-.242 10.359 2.594s-3.905 8.194-7.628 8.949S.739 13.218.164 10.382"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M10.905 9.137 9.096 12.03a1.35 1.35 0 0 1-1.146.636 1.354 1.354 0 0 1-1.352-1.35V9.577H3.712a1.376 1.376 0 0 1-1.326-1.003 1.4 1.4 0 0 1-.037-.588l.61-3.97a1.384 1.384 0 0 1 1.367-1.173h5.057c.315 0 .627.074.91.215l.451.225h1.704a.884.884 0 0 1 .885.885v4.083a.884.884 0 0 1-.885.885zm-.777-5.043-.281-.14a1.04 1.04 0 0 0-.465-.11H4.326a.38.38 0 0 0-.378.324l-.61 3.97a.37.37 0 0 0 .087.306.38.38 0 0 0 .289.133h3.384a.5.5 0 0 1 .5.5v2.238a.352.352 0 0 0 .65.186l1.88-3.007zm2.205 4.043V4.284h-1.205v3.853z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbDownStylized;